import type { Translations } from './en';

export const pt: Translations = {
  nav: {
    services: 'Servicos',
    portfolio: 'Portfolio',
    starModel: 'Modelo Estelar',
    partners: 'Parceiros',
    about: 'Sobre',
    contact: 'Contato',
    getStarted: 'Comecar',
    closeMenu: 'Fechar menu',
    openMenu: 'Abrir menu',
  },
  hero: {
    title: 'Construindo a Excelencia Empresarial do Amanha',
    subtitle: 'A Impresstars orquestra operacoes comerciais de alto desempenho atraves do nosso inovador sistema Star Model. Da incorporacao a estrategia de crescimento, somos seu parceiro na excelencia operacional.',
    exploreServices: 'Explorar Servicos',
    learnMore: 'Saiba Mais',
  },
  services: {
    eyebrow: 'O que fazemos',
    title: 'Nossos Servicos',
    incorporation: {
      title: 'Servicos de Incorporacao',
      description: 'Inicie seu negocio corretamente com nosso processo de incorporacao simplificado. Constituicao de LLC, Corp ou sem fins lucrativos de forma simples.',
    },
    aiSolutions: {
      title: 'Solucoes de IA',
      description: 'Servicos de integracao de IA personalizada incluindo modelos de aprendizado de maquina, processamento de linguagem natural e sistemas de decisao automatizada.',
    },
    b2bSolutions: {
      title: 'Solucoes B2B',
      description: 'Servicos B2B abrangentes incluindo desenvolvimento de parcerias, otimizacao da cadeia de suprimentos e terceirizacao de processos comerciais.',
    },
    marketingStrategy: {
      title: 'Estrategia de Marketing',
      description: 'Estrategias de marketing baseadas em dados adaptadas aos seus objetivos de negocio, incluindo analise de mercado e planejamento de crescimento.',
    },
    businessSoftware: {
      title: 'Software Empresarial',
      description: 'Identifique e implemente as solucoes de software certas para otimizar suas operacoes e aumentar a produtividade.',
    },
    brandDesign: {
      title: 'Design de Marca',
      description: 'Design profissional de logotipos, desenvolvimento de identidade de marca e materiais de marketing que causam impressoes duradouras.',
    },
    businessConsulting: {
      title: 'Consultoria Empresarial',
      description: 'Orientacao estrategica para otimizar suas operacoes e acelerar o crescimento atraves de metodologias comprovadas.',
    },
    ctaTitle: 'Pronto para Transformar Seu Negocio?',
    ctaText: 'Vamos conversar sobre como nossos servicos podem ajuda-lo a alcancar seus objetivos.',
    ctaButton: 'Comecar',
  },
  starModel: {
    eyebrow: 'Conectados por design',
    title: 'Modelos Estelares',
    description: 'Descubra nosso ecossistema de unidades de negocio especializadas e a metodologia operacional por tras delas.',
    learnHow: 'Como Funciona o Modelo Estelar',
    captionLeft: 'Operacoes conectadas',
    captionRight: 'Impulso compartilhado',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Ativo',
      description: 'Servicos profissionais de limpeza reinventados atraves de tecnologia e padroes de servico excepcionais.',
      details: 'A Cleaning EDGE e uma empresa de limpeza profissional focada em servicos residenciais e comerciais confiaveis, incluindo limpeza pos-obra e detalhamento automotivo, com fluxos de trabalho digitais que facilitam o agendamento, a comunicacao e o acompanhamento do servico.',
    },
    ozean: {
      title: 'Ozean',
      status: 'Desenvolvimento',
      description: 'Uma plataforma de audio stock que oferece recursos sonoros para criadores, editores, marcas e contadores de historias.',
      details: 'A Ozean foca em audio stock curado, ajudando equipes criativas a encontrar faixas e elementos sonoros para producao de conteudo.',
    },
    visitWebsite: 'Visitar Site',
  },
  testimonials: {
    eyebrow: 'Historias de clientes',
    title: 'Depoimentos de Clientes',
    description: 'Nao confie apenas na nossa palavra — ouca o que nossos clientes tem a dizer sobre trabalhar com a Impresstars.',
    j94Designs: 'A Impresstars nos apoiou com consultoria de RH e tambem nos ajudou a construir partes chave do nosso site Wix.',
    craftPapi: 'A Impresstars desenvolveu um plano de marketing pratico para nossa equipe, tornando nossas campanhas e prioridades muito mais claras.',
    pawStuffs: 'A Impresstars continua a apoiar nosso site Shopify e fornece suporte continuo a medida que nossa loja cresce.',
  },
  portfolio: {
    eyebrow: 'Trabalho selecionado',
    title: 'Nosso Portfolio',
    description: 'Explore nossos projetos recentes e historias de sucesso em diversas industrias e servicos.',
    filterAll: 'Todos',
    filterWebsites: 'Sites',
    filterApps: 'Apps e Ferramentas',
    filterGames: 'Jogos',
    filterConsulting: 'Consultoria',
    production: 'Producao',
    showcase: 'Vitrine',
    viewCaseStudy: 'Ver Estudo de Caso',
    visitSite: 'Visitar Site',
    openProject: 'Abrir Projeto',
    viewServices: 'Ver Nossos Servicos',
    startProject: 'Iniciar um Projeto',
    filterAllProjects: 'Todos os Projetos',
    filterRealWorld: 'Producao',
    filterShowcase: 'Vitrine',
    sortFeatured: 'Destacados',
    sortAZ: 'Titulo: A-Z',
    sortZA: 'Titulo: Z-A',
    sortLabel: 'Ordenar por:',
    reset: 'Redefinir',
    showing: 'Mostrando',
    of: 'de',
    projects: 'projetos',
    noProjects: 'Nenhum projeto encontrado para este filtro ainda.',
    visitProjectWebsite: 'Visitar o site do projeto',
    catBrandWebsite: 'Site de Marca',
    catWebDevelopment: 'Desenvolvimento Web',
    catEcommerceWebsite: 'Site E-commerce',
    catBusinessWebsite: 'Site Comercial',
    catWebsite: 'Site',
    catJewelleryBrand: 'Marca de Joalheria',
    catWebApp: 'App Web',
    catInteractiveApp: 'App Interativo',
    catUtilityTool: 'Ferramenta Util',
    cat3DWebSandbox: 'Sandbox Web 3D',
    catWebGame: 'Jogo Web',
    catGameExperience: 'Experiencia de Jogo',
    catConsultingMarketingPlan: 'Consultoria e Plano de Marketing',
    desc: {
      snouts: 'Trabalho web apoiando a presenca online da marca Snouts.',
      innovaPro: 'Entrega de site para Innova Pro focada em uma apresentacao clara de servicos e forte desempenho.',
      pawstuffs: 'Presenca web e-commerce e suporte de loja para Pawstuffs.',
      cleaningEdge: 'Trabalho de site e presenca digital para Cleaning EDGE.',
      cheesePanic: 'Gato cacando rato, rato quer queijo. Um joguinho web caotico.',
      cleaningEdgeApp: 'Plataforma de autoatendimento focada em operacoes para clientes e trabalhadores da Cleaning EDGE. Teste a demo de desenvolvimento com a senha cleaningEDGE e selecione Legacy Mode.',
      angoloDiamonds: 'Trabalho de desenvolvimento web para Angolo Diamonds.',
      craftPapiGrowth: 'Desenvolvimento de plano de consultoria e marketing para Craft Papi para fortalecer o posicionamento e a execucao do crescimento.',
      roboticVoiceClicker: 'Experiencia de clicker ativada por voz com interacao divertida de botao-lagarto.',
      cheatCounter: 'Jorge olhou novamente a carta do topo do seu deck. Alguem precisava contar.',
      klondikeSolitaire: 'Apresentacao e interacao de jogo web inspirado no solitario classico.',
      universeAdventure: 'Conceito de aventura espacial com viagens galacticos e exploracao baseada em naves.',
      interiorDesign3d: 'Uma sandbox de navegador Three.js para importar modelos 3D e construir cenas de interiores.',
      pavillionJewellery: 'Apresentacao de site voltada para marca para Pavillion Jewellery.',
      hauntedGalleria: 'Um site vitrine imersivo de tema sombrio para uma experiencia de galeria assombrada com visuais atmosfericos e animacoes sinistras.',
    },
  },
  partners: {
    eyebrow: 'Tecnologia Confiavel',
    title: 'Ferramentas que Usamos e Recomendamos',
    description: 'Estas sao plataformas com as quais trabalhamos ativamente e recomendamos aos nossos clientes. Se voce se inscrever atraves de nossos links, podemos ganhar uma indicacao — sem custo extra para voce.',
    teaserEyebrow: 'Tecnologia Confiavel',
    teaserTitle: 'Ferramentas que Recomendamos',
    seeAllPartners: 'Ver Todos os Parceiros',
    getStarted: 'Comecar',
    ctaTitle: 'Precisa de Ajuda para Escolher o Stack Certo?',
    ctaText: 'Avaliamos, implementamos e integramos ferramentas em seu fluxo de trabalho. Deixe a tecnologia conosco para que voce se concentre no seu negocio.',
    ctaButton: 'Fale Conosco',
    disclaimer: 'Alguns links nesta pagina sao links de indicacao. A Impresstars pode ganhar uma comissao se voce se inscrever — sem custo extra para voce.',
    catProductivity: 'Produtividade',
    catAIVoice: 'IA e Voz',
    catBusinessPhone: 'Telefone Comercial',
    catAIWebBuilder: 'Construtor Web IA',
  },
  about: {
    eyebrow: 'Nosso proposito',
    title: 'Sobre a Impresstars',
    p1: 'Na Impresstars, acreditamos em transformar operacoes comerciais atraves de inovacao e excelencia. Nossa missao e ajudar empresas a alcancar seu potencial maximo implementando solucoes de ponta e metodologias comprovadas.',
    p2: 'Fundada nos principios de excelencia operacional e crescimento sustentavel, desenvolvemos nosso unico sistema Star Model que ajudou inumeros negocios a alcancar sucesso notavel.',
  },
  clients: {
    title: 'Nossos Clientes',
    description: 'Temos orgulho de trabalhar com estas organizacoes e ajuda-las a crescer atraves de nossos servicos e suporte dedicado.',
  },
  techPlatforms: {
    title: 'Tecnologias e Plataformas que Suportamos',
    description: 'Podemos ajudar com implementacao, otimizacao ou suporte nessas ferramentas e plataformas.',
    catEcommerce: 'E-commerce e Sites',
    catAI: 'IA e Automacao',
    catMarketing: 'Marketing e Crescimento',
    catCloud: 'Cloud e Infraestrutura',
    catCreative: 'Producao Criativa e de Marca',
    focusEcommerce: 'Competencia central: lancamento e suporte de lojas e sites focados em conversao.',
    focusAI: 'Competencia central: adocao pratica de IA e automacao de fluxos de trabalho para equipes em crescimento.',
    focusMarketing: 'Competencia central: acompanhamento de desempenho, execucao de campanhas e SEO fundamental.',
    focusCloud: 'Competencia central: implantacao confiavel e suporte de ambientes para operacoes web modernas.',
    focusCreative: 'Competencia central: ativos de execucao de marca que apoiam marketing e narrativa de produtos.',
  },
  contact: {
    title: 'Entre em Contato',
    description: 'Pronto para transformar seu negocio? Envie-nos uma mensagem e retornaremos em ate 24 horas.',
    name: 'Nome',
    namePlaceholder: 'Seu nome',
    email: 'Email',
    emailPlaceholder: 'seu@email.com',
    reason: 'Motivo do Contato',
    reasonPlaceholder: 'Selecione um motivo',
    message: 'Mensagem',
    messagePlaceholder: 'Como podemos ajuda-lo?',
    sending: 'Enviando...',
    send: 'Enviar Mensagem',
    successTitle: 'Mensagem Enviada!',
    successText: 'Obrigado por entrar em contato. Retornaremos em breve.',
    sendAnother: 'Enviar Outra Mensagem',
    recaptchaError: 'Por favor, conclua a verificacao reCAPTCHA.',
    submitError: 'Envio falhou. Tente novamente ou nos envie um email diretamente.',
    reasons: {
      incorporationServices: 'Servicos de Incorporacao',
      aiSolutions: 'Solucoes de IA',
      b2bSolutions: 'Solucoes B2B',
      marketingStrategy: 'Estrategia de Marketing',
      businessSoftware: 'Software Empresarial',
      brandDesign: 'Design de Marca',
      businessConsulting: 'Consultoria Empresarial',
      websiteDevelopment: 'Desenvolvimento Web',
      websiteSupport: 'Suporte / Manutencao Web',
      ecommerceSupport: 'Suporte E-commerce',
      generalQuestion: 'Pergunta Geral',
      partnership: 'Oportunidade de Parceria',
    },
  },
  footer: {
    tagline: 'Transformando operacoes comerciais atraves de inovacao e excelencia.',
    quickLinks: 'Links Rapidos',
    starModels: 'Modelos Estelares',
    legal: 'Legal',
    termsConditions: 'Termos e Condicoes',
    privacyPolicy: 'Politica de Privacidade',
    contactTitle: 'Contato',
    city: 'London, ON',
    country: 'Canada',
    rightsReserved: 'Impresstars. Todos os direitos reservados.',
    notALawFirm: 'A Impresstars nao e um escritorio de advocacia e nao fornece aconselhamento juridico.',
  },
  notFound: {
    title: 'Pagina Nao Encontrada',
    metaDescription: 'A pagina que voce procura nao existe ou foi movida.',
    heading: 'Pagina Nao Encontrada',
    text: 'A pagina que voce procura nao existe ou pode ter sido movida. Vamos coloca-lo de volta no caminho.',
    backHome: 'Voltar ao Inicio',
    contactUs: 'Contate-nos',
    portfolio: 'Portfolio',
    services: 'Servicos',
  },
  caseStudy: {
    notFound: 'Estudo de Caso Nao Encontrado',
    returnHome: 'Voltar ao Inicio',
    backToPortfolio: 'Voltar ao Portfolio',
    client: 'Cliente:',
    challenge: 'O Desafio',
    solution: 'Nossa Solucao',
    keyResults: 'Resultados Chave',
    technologiesUsed: 'Tecnologias Utilizadas',
    visitProject: 'Visitar Projeto',
    items: {
      cleaningEdgePlatform: {
        title: 'Plataforma Cleaning EDGE',
        category: 'Desenvolvimento Web',
        client: 'Cleaning EDGE',
        description: 'Uma plataforma digital abrangente para gerenciar servicos de limpeza, incluindo agendamento, gestao de equipes e feedback de clientes.',
        challenge: 'O cliente precisava de uma solucao escalavel para gerenciar suas operacoes crescentes de servico de limpeza, lidar com reservas de clientes e otimizar o agendamento de equipes em multiplos locais.',
        solution: 'Desenvolvemos uma plataforma web personalizada que integra gestao de reservas, agendamento de equipes e acompanhamento em tempo real. A solucao inclui um portal de clientes, painel de administracao e interface amigavel para celulares para equipes de limpeza.',
        results: [
          'Reducao de conflitos de agendamento em 95%',
          'Aumento da satisfacao do cliente para 98%',
          'Melhoria da eficiencia da equipe em 40%',
          'Expansao para 3 novos locais',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'Painel de Analise com IA',
        category: 'Solucoes de IA',
        client: 'TechVision Inc.',
        description: 'Painel de analise personalizado usando aprendizado de maquina para prever tendencias comerciais e otimizar operacoes.',
        challenge: 'O cliente tinha dificuldade em dar sentido a sua vasta coleta de dados e precisava de insights preditivos para tomar melhores decisoes comerciais.',
        solution: 'Implementamos um sistema de aprendizado de maquina que analisa dados historicos, prevê tendencias e fornece insights acionaveis atraves de uma interface de painel intuitiva.',
        results: [
          'Aumento da precisao de previsao em 85%',
          'Reducao do tempo de tomada de decisao em 60%',
          'Geracao de US$ 2M em economia de custos',
          'Melhoria da gestao de estoque em 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Campanha de Marketing Global',
        category: 'Estrategia de Marketing',
        client: 'Global Solutions Ltd',
        description: 'Estrategia abrangente de marketing digital que aumentou a presenca de mercado do cliente em tres continentes.',
        challenge: 'O cliente precisava expandir sua presenca de mercado globalmente mantendo mensagens de marca consistentes e engajamento em diferentes contextos culturais.',
        solution: 'Desenvolvemos uma estrategia de marketing multicanal com conteudo localizado, publicidade direcionada e adaptacao cultural dos materiais de marketing.',
        results: [
          'Alcancamos mais de 2M de novos clientes potenciais',
          'Aumento das vendas globais em 150%',
          'Melhoria do reconhecimento de marca em 80%',
          'Gerado 300% de ROI no gasto de marketing',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Design e Desenvolvimento Web',
        client: 'Haunted Galleria',
        description: 'Um site vitrine imersivo de tema sombrio para uma experiencia de galeria assombrada — combinando visuais atmosfericos, animacoes sinistras e tipografia ousada.',
        challenge: 'O cliente precisava de uma presenca web que correspondesse a natureza dramatica e misteriosa do seu conceito de galeria assombrada.',
        solution: 'Criamos um site completamente personalizado com estetica dark ambiental, efeitos de paralaxe e tipografia inspirada no horror para criar suspense.',
        results: [
          'Identidade de marca de destaque em um mercado de nicho',
          'UX imersiva que mantem os visitantes engajados por mais tempo',
          'Totalmente responsivo em todos os dispositivos',
          'Otimizado para tempos de carregamento rapidos com efeitos visuais ricos',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Servicos de Incorporacao',
      metaDescription: 'Inicie sua jornada comercial com confianca. Nossos servicos de incorporacao fornecem uma base solida para o futuro sucesso de sua empresa.',
      intro: 'Inicie sua jornada comercial com confianca. Nossos servicos de incorporacao fornecem uma base solida para o futuro sucesso de sua empresa.',
      disclaimer: 'Aviso: A Impresstars nao e um escritorio de advocacia e nao fornece aconselhamento juridico. Recomendamos consultar um advogado qualificado para orientacao juridica.',
      structureOptions: 'Opcoes de Estrutura Empresarial',
      structureItems: [
        'Sociedade de Responsabilidade Limitada (LLC)',
        'Corporacao (C-Corp, S-Corp)',
        'Organizacao Sem Fins Lucrativos',
        'Formacoes de Sociedade',
      ],
      included: 'O Que Esta Incluso',
      includedItems: [
        'Busca de Nome Comercial',
        'Artigos de Incorporacao',
        'Registro EIN',
        'Acordo Operacional',
      ],
      ctaTitle: 'Pronto para se Incorporar?',
      ctaText: 'Vamos discutir a melhor estrutura para seu negocio e coloca-lo no caminho certo.',
      ctaButton: 'Agendar Consultoria',
    },
    aiSolutions: {
      title: 'Solucoes de IA',
      metaDescription: 'Transforme seu negocio com solucoes de inteligencia artificial de ponta adaptadas às suas necessidades especificas.',
      intro: 'Transforme seu negocio com solucoes de inteligencia artificial de ponta adaptadas às suas necessidades especificas.',
      servicesTitle: 'Servicos de IA',
      servicesItems: [
        'Modelos de Aprendizado de Maquina',
        'Processamento de Linguagem Natural',
        'Solucoes de Visao Computacional',
        'Analise Preditiva',
      ],
      implAreas: 'Areas de Implementacao',
      implItems: [
        'Automacao de Atendimento ao Cliente',
        'Analise de Dados e Insights',
        'Otimizacao de Processos',
        'Sistemas de Apoio a Decisao',
      ],
      ctaTitle: 'Pronto para Implementar IA?',
      ctaText: 'Vamos explorar como a IA pode revolucionar suas operacoes comerciais e impulsionar o crescimento.',
      ctaButton: 'Comecar',
    },
    b2bSolutions: {
      title: 'Solucoes B2B',
      metaDescription: 'Otimize suas operacoes business-to-business com nossas solucoes abrangentes projetadas para empresas modernas.',
      intro: 'Otimize suas operacoes business-to-business com nossas solucoes abrangentes projetadas para empresas modernas.',
      coreServices: 'Servicos Principais',
      coreServicesItems: [
        'Otimizacao da Cadeia de Suprimentos',
        'Desenvolvimento de Parcerias',
        'Terceirizacao de Processos',
        'Planejamento Estrategico',
      ],
      benefits: 'Beneficios',
      benefitsItems: [
        'Eficiencia Aumentada',
        'Reducao de Custos',
        'Expansao de Mercado',
        'Crescimento de Receita',
      ],
      ctaTitle: 'Transforme Suas Operacoes B2B',
      ctaText: 'Vamos otimizar seus relacionamentos e processos comerciais para maxima eficiencia.',
      ctaButton: 'Contate-nos',
    },
    marketingStrategy: {
      title: 'Estrategia de Marketing',
      metaDescription: 'Desenvolva uma poderosa estrategia de marketing que impulsiona o crescimento e se conecta com seu publico-alvo.',
      intro: 'Desenvolva uma poderosa estrategia de marketing que impulsiona o crescimento e se conecta com seu publico-alvo.',
      strategyComponents: 'Componentes da Estrategia',
      strategyItems: [
        'Analise de Mercado',
        'Pesquisa de Concorrentes',
        'Perfilagem do Publico-Alvo',
        'Estrategia de Canais',
      ],
      deliverables: 'Entregaveis',
      deliverablesItems: [
        'Plano de Marketing',
        'Estrategia de Conteudo',
        'Roadmap de Campanhas',
        'Projecoes de ROI',
      ],
      ctaTitle: 'Pronto para Crescer?',
      ctaText: 'Vamos criar uma estrategia de marketing que leve seu negocio ao proximo nivel.',
      ctaButton: 'Iniciar Planejamento',
    },
    brandDesign: {
      title: 'Design de Marca',
      metaDescription: 'Crie uma identidade de marca memoravel que ressoe com seu publico e se destaque no mercado.',
      intro: 'Crie uma identidade de marca memoravel que ressoe com seu publico e se destaque no mercado.',
      designServices: 'Servicos de Design',
      designItems: [
        'Design de Logotipo',
        'Diretrizes de Marca',
        'Identidade Visual',
        'Materiais de Marketing',
      ],
      deliverables: 'Entregaveis',
      deliverablesItems: [
        'Guia de Estilo de Marca',
        'Pacote de Logotipos',
        'Paleta de Cores',
        'Sistema Tipografico',
      ],
      ctaTitle: 'Pronto para um Novo Visual?',
      ctaText: 'Vamos criar uma identidade de marca que capture sua visao e se conecte com seu publico.',
      ctaButton: 'Iniciar Processo de Design',
    },
    businessConsulting: {
      title: 'Consultoria Empresarial',
      metaDescription: 'Obtenha orientacao especializada para otimizar suas operacoes e acelerar o crescimento comercial atraves de metodologias comprovadas.',
      intro: 'Obtenha orientacao especializada para otimizar suas operacoes e acelerar o crescimento comercial atraves de metodologias comprovadas.',
      consultingAreas: 'Areas de Consultoria',
      consultingItems: [
        'Planejamento Estrategico',
        'Otimizacao de Operacoes',
        'Analise Financeira',
        'Estrategia de Crescimento',
      ],
      benefits: 'Beneficios',
      benefitsItems: [
        'Eficiencia Melhorada',
        'Reducao de Custos',
        'Crescimento de Receita',
        'Melhor Tomada de Decisoes',
      ],
      ctaTitle: 'Pronto para Otimizar?',
      ctaText: 'Vamos analisar seu negocio e criar um plano para crescimento sustentavel.',
      ctaButton: 'Agendar Consultoria',
    },
    businessSoftware: {
      title: 'Solucoes de Software Empresarial',
      metaDescription: 'Transforme suas operacoes comerciais com solucoes de software cuidadosamente selecionadas e implementadas que otimizam processos e aumentam a eficiencia.',
      intro: 'Transforme suas operacoes comerciais com solucoes de software cuidadosamente selecionadas e implementadas que otimizam processos e aumentam a eficiencia.',
      ourApproach: 'Nossa Abordagem',
      approachItems: [
        'Analise de Processos de Negocio',
        'Levantamento de Requisitos de Software',
        'Avaliacao e Selecao de Solucoes',
        'Implementacao e Integracao',
      ],
      solutionAreas: 'Areas de Solucao',
      solutionItems: [
        'Sistemas ERP',
        'Plataformas CRM',
        'Ferramentas de Gestao de Projetos',
        'Desenvolvimento de Software Personalizado',
      ],
      ctaTitle: 'Pronto para Otimizar Suas Operacoes?',
      ctaText: 'Vamos identificar as solucoes de software perfeitas para transformar seus processos comerciais.',
      ctaButton: 'Agendar Consultoria',
    },
  },
  seo: {
    homeTitle: 'Construindo a Excelencia Empresarial do Amanha',
    homeDescription: 'A Impresstars orquestra operacoes comerciais de alto desempenho atraves do nosso inovador sistema Star Model. Da incorporacao a estrategia de crescimento, somos seu parceiro na excelencia operacional.',
    portfolioTitle: 'Portfolio',
    portfolioDescription: 'Explore nossa colecao completa de projetos bem-sucedidos e estudos de caso em diversas industrias.',
    partnersTitle: 'Ferramentas e Parceiros Recomendados',
    partnersDescription: 'Ferramentas e plataformas que a Impresstars usa e recomenda para clientes. Comece com tecnologia de primeira classe atraves de nossos links de indicacao.',
  },
  languageSwitcher: {
    label: 'Idioma',
  },
};
